import PropTypes from 'prop-types';
import Button from 'components/ui/button';
import ls from '@livesession/sdk';
import * as Styled from './styled';

const Intro = ({ buttonText }) => (
  <Styled.Section className="text-center">
    <div>
      <div className="signupAndProductTour">
        <Button signUp secondary={!buttonText} center sourceID="hero" style={{ fontSize: '18px' }}>
          {buttonText || 'Sign up free'}
        </Button>
      </div>
      <div className="signupAndProductTour">
        <Button
          href="/product-tour/"
          reversed={!buttonText}
          center
          sourceID="hero"
          style={{ fontSize: '18px' }}
          onClick={() => {
            ls.track('Clicked: View demo button');
          }}
        >
          {buttonText || 'View demo'}
        </Button>
      </div>
    </div>
  </Styled.Section>
);

export default Intro;

Intro.propTypes = {
  buttonText: PropTypes.string,
};

Intro.defaultProps = {
  buttonText: undefined,
};
